//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { ButtonLink } from "components/styles";
//#endregion
//#region Components
import DialogChangeHistory from "./components/DialogChangeHistory/DialogChangeHistory";
import { useEffect } from "react";
import { requestGetChangeHistoryUser } from "services/settings/roleAdmin/aboutRoleAdmin";
//#endregion

const ChangeHistory = ({
    user
}) => {
    //#region States
    const [showDialog, setShowDialog] = useState(false);
    const [changeHistory, setChangeHistory] = useState([]);
    //#endregion
    //#region Extra
    //#endregion
    //#region Effects
    useEffect(() => {
        fillChangeHistory();
    }, []);
    //#endregion
    //#region Functions
    const toggleShowDialog = (value = null) => {
        setShowDialog(value === null ? !showDialog : value);
    }
    //#endregion
    const fillChangeHistory = async () => {
        const fetchData = await requestGetChangeHistoryUser(user);
        setChangeHistory(fetchData);
    }
    return (
        <>
        <ButtonLink 
            className={changeHistory.length === 0 ? "disabled" : ""} 
            onClick={() => toggleShowDialog()}>Ver historial de cambios</ButtonLink>
        <DialogChangeHistory 
            show={showDialog}
            toggleShow={toggleShowDialog}
            changeHistory={changeHistory}/>
        </>
    );
}

export default ChangeHistory;